import { useEffect } from 'react';

type UseOutsideClickProps = {
  ref: React.RefObject<HTMLElement>;
  handlerClose: () => void;
  attached?: boolean;
  // Фаза перехвата нужна внутри Modal: он останавливает всплытие mousedown
  capture?: boolean;
};

export const useOutsideClick = ({
  ref,
  handlerClose,
  attached = true,
  capture = false,
}: UseOutsideClickProps) => {
  useEffect(() => {
    if (!attached) return undefined;

    const handlerOutsideClick = (e: MouseEvent) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target as Node)) {
        handlerClose();
      }
    };

    document.addEventListener('mousedown', handlerOutsideClick, capture);

    return () =>
      document.removeEventListener('mousedown', handlerOutsideClick, capture);
  }, [ref, handlerClose, attached, capture]);
};
